module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#043f61"
					},
					{
						"y": 82.85714285714286,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#09472e"
					},
					{
						"y": 65.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.92307692307692,
						"dataLabels": {
							"enabled": false,
							"format": "126"
						},
						"color": "#043f61"
					},
					{
						"y": 93.84615384615384,
						"dataLabels": {
							"enabled": false,
							"format": "122"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.53846153846153,
						"dataLabels": {
							"enabled": false,
							"format": "119"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#09472e"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.11504424778761,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#043f61"
					},
					{
						"y": 99.11504424778761,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#0c4250"
					},
					{
						"y": 99.11504424778761,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.2654867256637,
						"dataLabels": {
							"enabled": false,
							"format": "102"
						},
						"color": "#09472e"
					},
					{
						"y": 76.10619469026548,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.55947136563876,
						"dataLabels": {
							"enabled": false,
							"format": "452"
						},
						"color": "#043f61"
					},
					{
						"y": 99.55947136563876,
						"dataLabels": {
							"enabled": false,
							"format": "452"
						},
						"color": "#0c4250"
					},
					{
						"y": 98.89867841409692,
						"dataLabels": {
							"enabled": false,
							"format": "449"
						},
						"color": "#0d4440"
					},
					{
						"y": 95.81497797356829,
						"dataLabels": {
							"enabled": false,
							"format": "435"
						},
						"color": "#09472e"
					},
					{
						"y": 80.39647577092511,
						"dataLabels": {
							"enabled": false,
							"format": "365"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.25,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#09472e"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.72131147540983,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#043f61"
					},
					{
						"y": 95.08196721311475,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.80327868852459,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.32786885245902,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#09472e"
					},
					{
						"y": 57.377049180327866,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.93617021276596,
						"dataLabels": {
							"enabled": false,
							"format": "186"
						},
						"color": "#043f61"
					},
					{
						"y": 95.2127659574468,
						"dataLabels": {
							"enabled": false,
							"format": "179"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.95744680851064,
						"dataLabels": {
							"enabled": false,
							"format": "171"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.6595744680851,
						"dataLabels": {
							"enabled": false,
							"format": "146"
						},
						"color": "#09472e"
					},
					{
						"y": 53.72340425531915,
						"dataLabels": {
							"enabled": false,
							"format": "101"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.33481152993349,
						"dataLabels": {
							"enabled": false,
							"format": "448"
						},
						"color": "#043f61"
					},
					{
						"y": 97.11751662971176,
						"dataLabels": {
							"enabled": false,
							"format": "438"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.12638580931264,
						"dataLabels": {
							"enabled": false,
							"format": "420"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.24833702882484,
						"dataLabels": {
							"enabled": false,
							"format": "398"
						},
						"color": "#09472e"
					},
					{
						"y": 65.18847006651885,
						"dataLabels": {
							"enabled": false,
							"format": "294"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#043f61"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0c4250"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0d4440"
					},
					{
						"y": 51.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#09472e"
					},
					{
						"y": 31.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.15068493150685,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#043f61"
					},
					{
						"y": 90.41095890410958,
						"dataLabels": {
							"enabled": false,
							"format": "66"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.67123287671232,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.71232876712328,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#09472e"
					},
					{
						"y": 47.94520547945205,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.27586206896551,
						"dataLabels": {
							"enabled": false,
							"format": "171"
						},
						"color": "#043f61"
					},
					{
						"y": 84.48275862068965,
						"dataLabels": {
							"enabled": false,
							"format": "147"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.75862068965517,
						"dataLabels": {
							"enabled": false,
							"format": "144"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.13793103448276,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#09472e"
					},
					{
						"y": 51.724137931034484,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.86729857819904,
						"dataLabels": {
							"enabled": false,
							"format": "413"
						},
						"color": "#043f61"
					},
					{
						"y": 87.44075829383885,
						"dataLabels": {
							"enabled": false,
							"format": "369"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.83412322274881,
						"dataLabels": {
							"enabled": false,
							"format": "358"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.09478672985783,
						"dataLabels": {
							"enabled": false,
							"format": "338"
						},
						"color": "#09472e"
					},
					{
						"y": 62.08530805687204,
						"dataLabels": {
							"enabled": false,
							"format": "262"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.71428571428571,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.076923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1746031746031744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4590163934426257,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.563025210084029,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8849557522123908,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.92857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.686274509803921,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.4405286343612369,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.6637168141592875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.11804008908686,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.09195402298851,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2786885245901676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.6949152542372836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.0638297872340385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.7634408602150504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.469273743016755,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.619883040935678,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.82191780821918,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.6651884700665134,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.2321428571428603,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.109589041095896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.238095238095242,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.13065326633166,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.500000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.888888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.70967741935484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.849315068493156,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0303030303030276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.7241379310344862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.035087719298245,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0408163265306145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.416666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.23255813953488,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.1327014218009532,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.653753026634384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.981029810298108,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.586592178770955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.48520710059172,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=35"
			},
			{
				"x": 9,
				"text": "30-39<br>n=130"
			},
			{
				"x": 15,
				"text": "40-49<br>n=113"
			},
			{
				"x": 21,
				"text": ">=50<br>n=454"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=16"
			},
			{
				"x": 34,
				"text": "30-39<br>n=61"
			},
			{
				"x": 40,
				"text": "40-49<br>n=188"
			},
			{
				"x": 46,
				"text": ">=50<br>n=451"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=60"
			},
			{
				"x": 59,
				"text": "30-39<br>n=73"
			},
			{
				"x": 65,
				"text": "40-49<br>n=174"
			},
			{
				"x": 71,
				"text": ">=50<br>n=422"
			}
		],
		"dataTable": {
			"MSM:<30": [
				35,
				35,
				29,
				28,
				25,
				23
			],
			"MSM:30-39": [
				130,
				126,
				122,
				119,
				110,
				90
			],
			"MSM:40-49": [
				113,
				112,
				112,
				112,
				102,
				86
			],
			"MSM:>=50": [
				454,
				452,
				452,
				449,
				435,
				365
			],
			"Non-MSM:<30": [
				16,
				16,
				16,
				16,
				13,
				12
			],
			"Non-MSM:30-39": [
				61,
				59,
				58,
				56,
				49,
				35
			],
			"Non-MSM:40-49": [
				188,
				186,
				179,
				171,
				146,
				101
			],
			"Non-MSM:>=50": [
				451,
				448,
				438,
				420,
				398,
				294
			],
			"Unknown:<30": [
				60,
				40,
				39,
				36,
				31,
				19
			],
			"Unknown:30-39": [
				73,
				68,
				66,
				64,
				56,
				35
			],
			"Unknown:40-49": [
				174,
				171,
				147,
				144,
				129,
				90
			],
			"Unknown:>=50": [
				422,
				413,
				369,
				358,
				338,
				262
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 204
// module chunks = 0